import _ from "lodash";

import React from "react";
import { withApollo } from "react-apollo";
import { Link } from "react-router-dom";

import withStyles from "material-ui/styles/withStyles";
import SweetAlert from "react-bootstrap-sweetalert";
import ReactTable from "react-table";
import update from 'immutability-helper';

import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

import Select from 'react-select';
import EditIcon from "@material-ui/icons/Edit";
import PageviewIcon from "@material-ui/icons/Pageview";
import Close from "@material-ui/icons/Close";
import Check from "@material-ui/icons/Check";
import PeopleIcon from "@material-ui/icons/People";
import FolderIcon from "@material-ui/icons/Folder";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import VisibilityIcon from "@material-ui/icons/Visibility";
import Tooltip from 'material-ui/Tooltip';
import AddAlert from "@material-ui/icons/AddAlert";

import Badge from "components/Badge/Badge.jsx";
import GridContainer from "components/Grid/GridContainer";
import IconCard from "components/Cards/IconCard.jsx";
import ItemGrid from "components/Grid/ItemGrid";
import Button from "components/CustomButtons/Button.jsx";
import IconButton from "components/CustomButtons/IconButton.jsx";
import Snackbars from "components/Snackbar/Snackbar.jsx";

import { getUsersQuery, userData, getAllProjects, getUserSub } from "../graph";
import usersStyle from '../style';
import ShowPasswordModal from "./ShowPasswordModal";
import StatusModal from "./StatusModal";
import ExportUsersModal from "./ExportUsersModal";
import ImportUsersModal from "./ImportUsersModal";
import { downloadFile } from "lib/utils" ;

import {client} from "client";


import CustomDropdown from 'components/CustomDropdown/CustomDropdown.jsx';


class Users extends React.Component {
    constructor(props){
      super(props);
      this.state = {
          users: [],
          statusModalIsOpen: false,
          selectedId: "", 
          pages: 0, 
          loading: true,
          showPasswordModalIsOpen: false,
          exportModalIsOpen: false,
          projectSelectValue: 0
      };

      this.projectList = [{
        label: "All users",
        value: 0
      }];

      this.onUserStatusBtnClick=this.onUserStatusBtnClick.bind(this);
      this.fetchData = this.fetchData.bind(this)
      this.selectedUser = null;
      this.pwd = null;
      this.subscription = null;
      this.pageSize = 10;
    }

    componentDidMount(){
      if (!_.isEmpty(this.props.match.params)) {
        this.state.projectSelectValue = this.props.match.params.pid;
        this.setState({
          projectSelectValue: this.props.match.params.pid
        });
      }

      this.props.getUsersQuery.subscribeToMore({
          document: getUserSub,
          updateQuery: (previousResult, { subscriptionData }) => {
            const data = JSON.parse(subscriptionData.data.userSub.jsonObject);
            let users = this.state.users;  
            let newUsers = [];

            if (data.operation_type == "add") {
              if (users.length < this.pageSize) {
                newUsers = update(users, {$push: [JSON.parse(data.user)]});
                this.setState({users: newUsers});
              }
            }
            else if (data.operation_type == "edit") {
              const dataUser = JSON.parse(data.user);

              //will update later to use the immutability helper instead of looping
              //but this can work for now, since page size is not that big
              for (let i in users) {
                if (users[i].uid == dataUser.uid)
                  newUsers.push(dataUser);
                else
                  newUsers.push(users[i]);
              }

              this.setState({users: newUsers});
            }

          }
      });

      this.props.client.query({
        query: getAllProjects
      }).then((data) => {
        const pEdges = data.data.allProjects.edges;

        for (const i in pEdges) {
          this.projectList.push({
            label: pEdges[i].node.name,
            value: pEdges[i].node.pid
          });
        }
      });

      this.fetchData();
    }

    onUserStatusBtnClick(user, event) {
        this.setState({selectedId: user.uid})
        this.selectedUser = user;
        this.setState({
            statusModalIsOpen: true
        });
    }

    onStatusModalCallback(id, newStatus) {
        const users = this.state.users;  
        let newUsers = [];

        for (const i in users) {
            let user = Object.assign({}, users[i]);
            
            if (user["uid"] === id) {
                user["active"] = newStatus;
            } 
            
            newUsers.push(user);
        }

        this.setState({users: newUsers});
    }

    onStatusModalClose() {
        this.setState({
            statusModalIsOpen: false
        });
    }

    fetchData(state=null, instance=null){
      console.log('fetchdata');
      console.log(state);
        this.setState({ loading: true })
        if (state){
            var filterBy = JSON.stringify(state.filtered)
            var offset = state.page
            var pageSize = state.pageSize
            var sort = JSON.stringify(state.sorted)
        } else {
            var filterBy = JSON.stringify([])
            var offset = 0
            var pageSize = 10
            var sort = JSON.stringify([])
        }

        this.pageSize = pageSize;

        this.props.client.query({
            query: getUsersQuery,
            variables: {
                filterBy: filterBy,
                offset: offset, 
                pageSize: pageSize,
                sort: sort,
                project: parseInt(this.state.projectSelectValue)
            },
            fetchPolicy: "network-only"
        }).then((data) => {
            this.setState({
                users: data.data.users.users, 
                loading: false, 
                pages: data.data.users.pages, 
                hasNext: data.data.users.hasNext, 
                hasPrev: data.data.users.hasPrev
            });
        });
    }

    onViewPassworkClick(user, event) {
        this.selectedUser = user;

        this.props.getUserPassword({
            variables:{
                uid: user.uid,
            }
        }).then((data) => {
            this.pwd = data.data.getUserPassword.pwd;
            this.setState({
                showPasswordModalIsOpen: true
            });
        }).catch(({errors}) => {
            console.log(errors);
        });
    }

    onViewPasswordClose() {
        this.setState({
            showPasswordModalIsOpen: false
        });
    }

    onDownloadButtonClick() {
        this.setState({exportModalIsOpen: true});
    }

    onDownloadButtonCancel() {
        this.setState({exportModalIsOpen: false});
    }

    onDownloadButtonConfirm(evt) {
        const project = this.state.projectSelectValue;
        let url = "";

        if (project === 0)
            url = `${process.env.REACT_APP_SERVER_URL}export_users/`
        else
            url = `${process.env.REACT_APP_SERVER_URL}export_users/${project}`
               
        downloadFile(url, "tp-users.csv");
        this.setState({exportModalIsOpen: false});
    }

    onProjectSelectChange(event) {
        this.setState({
          projectSelectValue: event.value
        });
        this.props.client.query({
            query: getUsersQuery,
            variables: {
                filterBy: JSON.stringify([]),
                offset: 0, 
                pageSize: 10,
                sort: JSON.stringify([]),
                project: parseInt(event.value)
            },
            fetchPolicy: "network-only"
        }).then((data) => {
            this.setState({
                users: data.data.users.users, 
                loading: false, 
                pages: data.data.users.pages, 
                hasNext: data.data.users.hasNext, 
                hasPrev: data.data.users.hasPrev
            });
        });
    }

    onUploadButtonClick(){
        this.setState({
            importModalisOpen: true
        });
    }

    render() {
        let _this = this;
        let active = <Badge color="primary">Active</Badge>
        let deactivated = <Badge color="danger">Deactivated</Badge>

        let { statusModalIsOpen, showPasswordModalIsOpen, exportModalIsOpen, projectSelectValue } = this.state;
        let statusModal = null;
        const {classes} = this.props;
        let showPwdModal = null;
        let showExportModal = null;
        let showImportModal = null;

        if (showPasswordModalIsOpen)
            showPwdModal = (
                        <ShowPasswordModal password={this.pwd}
                            user={this.selectedUser}
                            onViewPasswordClose={this.onViewPasswordClose.bind(this)}/>
            );

        if (exportModalIsOpen)
            showExportModal = (
                <ExportUsersModal
                    onDownloadButtonConfirm={this.onDownloadButtonConfirm.bind(this)}
                    onDownloadButtonCancel={this.onDownloadButtonCancel.bind(this)} />
            );

        if (statusModalIsOpen)
            statusModal = <StatusModal 
                                user={this.selectedUser} 
                                onStatusModalCallback={this.onStatusModalCallback.bind(this)}
                                statusModalIsOpen={statusModalIsOpen}
                                onStatusModalClose={this.onStatusModalClose.bind(this)}/>

        if (this.state.importModalisOpen)
            if (this.state.projectSelectValue == 0)
                showImportModal = <Snackbars
                      place="tc"
                      color="danger"
                      icon={AddAlert}
                      message="Please select a project"
                      open={this.state.importModalisOpen}
                      // closeNotification={this.props.closeErrorSnackbar}
                      close
                    />
            else
                showImportModal = (
                    <ImportUsersModal
                        project={this.state.projectSelectValue}
                        handleClose={() => this.setState({importModalisOpen: false})}
                        open={this.state.importModalisOpen}
                        pid={this.state.projectSelectValue}
                        projid={this.state.projectSelectValue}
                        confirmImport={()=> console.log("import")}
                        onSuccess={() => console.log("success")}
                    />
            )
        let table = <ReactTable
                        data={
                            _this.state.users.map((prop,key) => {
                                let activeColor = "dangerNoBackground";
                                let activeIcon = (<Close />);
                                let utype = 'FWP';

                                if (prop.usertype == process.env.REACT_APP_ADMIN_ROLE)
                                    utype = 'ADMIN';
                                else if (prop.usertype == process.env.REACT_APP_PM_ROLE)
                                    utype = 'PM';

                                if (!prop.active) {
                                    activeColor = "successNoBackground";
                                    activeIcon = (<Check />);
                                }

                                return ({
                                    id: key,
                                    username: prop.username,
                                    usertype: utype,
                                    active: (prop.active) ? active : deactivated,
                                    uid: prop.uid,
                                    actions: (
                                    <div className="actions-right">
                                        <Tooltip
                                            id="tooltip-top"
                                            title="Show Password"
                                            placement="top"
                                            classes={{ tooltip: classes.tooltip }}
                                        >
                                            <IconButton
                                                onMouseDown={ _this.onViewPassworkClick.bind(_this, prop) }
                                                color="roseNoBackground">
                                                <VisibilityIcon />
                                            </IconButton>
                                        </Tooltip>{" "}
                                        <Link to={`/users/${prop.uid}`}>
                                            <Tooltip
                                                id="tooltip-top"
                                                title="View user"
                                                placement="top"
                                                classes={{ tooltip: classes.tooltip }}
                                            >
                                                <IconButton
                                                    onClick={()=>{console.log('view')}}
                                                    color="infoNoBackground"
                                                    customClass="like">
                                                    <PageviewIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </Link>{" "}
                                        <Link to={`/users/${prop.uid}/update`}>
                                            <Tooltip
                                                id="tooltip-top"
                                                title="Edit user"
                                                placement="top"
                                                classes={{ tooltip: classes.tooltip }}
                                            >
                                            <IconButton
                                                onClick={()=>{console.log('edit')}}
                                                color="warningNoBackground"
                                                customClass="edit">
                                                <EditIcon />
                                            </IconButton>
                                            </Tooltip>
                                        </Link>{" "}
                                        { /* use this button to remove the data row */ }
                                        <Tooltip
                                            id="tooltip-top"
                                            title="Deactivate user"
                                            placement="top"
                                            classes={{ tooltip: classes.tooltip }}
                                        >
                                        <IconButton
                                            onClick={ _this.onUserStatusBtnClick.bind(_this, prop) }
                                            color={activeColor}
                                            customClass="remove">
                                            {activeIcon}
                                        </IconButton>
                                        </Tooltip>{" "}
                                        </div>
                                    )
                                })
                            })
                        }
                        columns={[
                            {
                                Header: "Username",
                                accessor: "username",
                            },
                            {
                                Header: "Usertype",
                                accessor: "usertype",
                            },
                            {
                                Header: "Status",
                                accessor: "active",
                                sortable: false,
                                filterable: false,
                            },
                            {
                                Header: "Actions",
                                accessor: "actions",
                                sortable: false,
                                filterable: false,
                            }
                            ]}
                        defaultPageSize={10}
                        showPaginationTop
                        showPaginationBottom={false}
                        className="-striped -highlight"
                        manual
                        filterable
                        pages={_this.state.pages}
                        loading={_this.state.loading}
                        onFetchData={_this.fetchData}
                    />;

        return(      
            <GridContainer>
                {statusModal}
                {showPwdModal}
                {showExportModal}
                {showImportModal}
                <ItemGrid xs={12}>
                    <IconCard
                        icon={ PeopleIcon }
                        title="Users"
                        content={ 
                            <GridContainer>
                            <style>
                                {`
                                    .users-paddingleft {
                                        padding-left: 0 !important;
                                    }
                                    .users-selecttop {
                                        margin-top: 9px;
                                    }
                                `}
                              </style>
                                <ItemGrid xs={12} md={12} style={{display : "inline-flex"}}>
                                    <ItemGrid xs={12} md={4} className="users-paddingleft users-selecttop">
                                        <Select options={this.projectList} onChange={this.onProjectSelectChange.bind(this)} value={projectSelectValue} clearable={false}/>
                                    </ItemGrid>
                                    <ItemGrid xs={12} md={2} className="users-paddingleft">
                                        <CustomDropdown
                                          dropdownHeader="Actions"
                                          buttonText="Actions"
                                          buttonProps={{
                                            color: "primary"
                                          }}
                                          buttonIcon2={<FolderIcon />}
                                          dropdownList={[
                                            {"label": "Export Users", "onClick":this.onDownloadButtonClick.bind(this), "icon": <CloudDownloadIcon />},
                                            {"label": "Import Users", "onClick":this.onUploadButtonClick.bind(this), "icon": <CloudUploadIcon />}
                                          ]}
                                        />
                                    </ItemGrid>
                                </ItemGrid>
                                <ItemGrid xs={12} style={{marginTop: "15px"}}>
                                    {table}
                                </ItemGrid>
                            </GridContainer>
                        }
                    />
                </ItemGrid>
            </GridContainer>
        )
    }
}

export default withStyles(usersStyle, sweetAlertStyle)((userData)(withApollo(Users)));



// WEBPACK FOOTER //
// ./src/views/users/components/Users.js